import React from "react";
import laptop from "../../../assets/img/promocionBlustay/imagen_laptop.png";

const Laptop = () => {
    return (
        <div className="w-full mt-7">
            <div className="flex flex-col w-3/4 mx-auto justify-center items-center">
                <div className="text-center md:text-2xl text-lg text-[#029DE0] font-extrabold ">
                    Todo en tu propia web completamente personalizada
                </div>

                <img src={laptop} alt="w-full" className="" />

                <div className="text-center md:text-md xs:text-sm text-xs mt-3 mb-7 font-semibold">
                    Todo tu negocio en una sola pantalla. Centraliza las
                    reservas de todos tus canales en un calendario único que se
                    actualiza al instante. Ahorra tiempo y gestiona sin errores.
                </div>
            </div>
        </div>
    );
};

export default Laptop;
